<app-ui-document-panel-shell
  [breadcrumb]="breadcrumb"
  [title]="panelTitle"
  [documentId]="so_no || ''"
  [statusLabel]="statusLabel"
  [statusVariant]="statusVariant"
  (closed)="onClose()">

  <app-ui-approval-stepper *ngIf="data?.id" [steps]="approvalSteps"></app-ui-approval-stepper>

  <app-ui-form-section title="General Information" icon="info">
  <div style="display: flex; justify-content: start; gap: 30px; flex-wrap: wrap; max-width: 100%;">
    <!-- <div style="flex: 1;">
      <mat-form-field appearance="outline" style="width: 60%;">
        <mat-label>Select store <span style="color: red">*</span></mat-label>
        <mat-select [(ngModel)]="store_data" placeholder="Select Store"  (ngModelChange)="fetchSo();fetchSkuData($event)" [disabled]="isUpdateMode">
          <mat-option *ngFor="let item of store" [value]="item.id">{{ item.store_name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->
    <div style="flex: 0 1 auto; min-width: 200px; margin-bottom: 15px;">
      <div [matTooltip]="getCustomerName(customer)" [matTooltipDisabled]="!customer || !(isUpdateMode || isInputDisabled)">
        <mat-form-field appearance="outline" [style.width]="getCustomerFieldWidth() + 'px'">
          <mat-label>Select customer <span style="color: red">*</span></mat-label>
          <mat-select #customerSelect [(ngModel)]="customer" placeholder="Select Customer"
            (ngModelChange)="onCustomerChange($event)" (openedChange)="onCustomerOpen($event)"
            [disabled]="isUpdateMode || isInputDisabled">
            <mat-option disabled>
              <input matInput placeholder="Search Customer..." (keyup)="onCustomerSearch($event.target.value)"
                (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            </mat-option>
            <mat-option *ngFor="let item of customer_data" [value]="item.id" [disabled]="item.approval_status != 'Approved'">
              {{ item.customer_name }}
            </mat-option>
            <mat-option *ngIf="loadingCustomer" disabled>
              Loading...
            </mat-option>
          </mat-select>
          <!-- <mat-select [(ngModel)]="customer" placeholder="Select Customer" (ngModelChange)="onCustomerChange($event)"
            [disabled]="isUpdateMode || isInputDisabled">
            <ng-container *ngFor="let item of customer_data">
              <mat-option *ngIf="item.approval_status == 'Approved'" [value]="item.id">
                {{ item.customer_name }}
              </mat-option>
            </ng-container>
          </mat-select> -->
        </mat-form-field>
      </div>
    </div>
  <div style="flex: 0 1 auto; min-width: 200px; margin-bottom: 15px;">
  <div [matTooltip]="getBranchName(selectedBranch)" [matTooltipDisabled]="!selectedBranch || !(isUpdateMode || isInputDisabled)">
    <mat-form-field appearance="outline" [style.width]="getCustomerBranchFieldWidth() + 'px'">
      <mat-label>Select Customer Branch<span style="color: red">*</span></mat-label>
      <mat-select
        [(ngModel)]="selectedBranch"
        (ngModelChange)="onBranchChange(selectedBranch); fetchContactPersons(customer, selectedBranch);"
        placeholder="Select Customer Branch"
        [disabled]="isUpdateMode || isInputDisabled">
        <mat-option *ngFor="let branch of customerbranch" [value]="branch.id">
          {{ branch.branch_name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
   
    <div style="flex: 1;">
      <div [matTooltip]="getCustomerBranchName(branch)" 
        [matTooltipDisabled]="!branch || !(isUpdateMode || isInputDisabled)">
        <mat-form-field appearance="outline" style="width: auto;">
          <mat-label>Branch<span style="color: red">*</span></mat-label>
          <mat-select #branchSelect [(ngModel)]="branch" (ngModelChange)="fetchProfitCost(branch)"
            (openedChange)="onBranchOpen($event)" [disabled]="isUpdateMode || isInputDisabled">
            <mat-option disabled>
              <input matInput placeholder="Search Branch..." (keyup)="onBranchSearch($event.target.value)"
                (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            </mat-option>
            <mat-option *ngFor="let data of branchdata" [value]="data.id">
              {{ data.name }}
            </mat-option>
            <mat-option *ngIf="loadingBranch" disabled>
              Loading...
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div style="flex: 0 1 auto; min-width: 200px; margin-bottom: 15px;">
      <div [matTooltip]="getProfitCostNames(profitcost)" 
        [matTooltipDisabled]="!profitcost?.length || !isInputDisabled">
        <mat-form-field appearance="outline" [style.width]="getProfitCostFieldWidth() + 'px'">
          <mat-label>Select profit/cost center <span style="color: red">*</span></mat-label>
          <mat-select [(ngModel)]="profitcost" placeholder="Select profit/cost center" multiple
            (ngModelChange)="fetchSection(profitcost)" (selectionChange)="onProfitCostChange($event)"
            [disabled]="isInputDisabled">
            <mat-option *ngFor="let item of filteredProfitCost" [value]="item.id" [disabled]="item.disabled">
              {{ item.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
 
    <div style="flex: 0 1 auto; min-width: 200px; margin-bottom: 15px;">
      <div [matTooltip]="getErpCodes(profitcost)" [matTooltipDisabled]="!profitcost?.length || !isInputDisabled">
        <mat-form-field appearance="outline" [style.width]="getProfitCostFieldWidth() + 'px'">
          <mat-label>Select ERP Code <span style="color: red">*</span></mat-label>
          <mat-select [(ngModel)]="profitcost" placeholder="Select ERP Code" multiple
            (ngModelChange)="fetchSection(profitcost)" [disabled]="isInputDisabled">
            <mat-option *ngFor="let item of filteredProfitCost" [value]="item.id" [disabled]="item.disabled">
              {{ item.erp_code }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
<div style="flex: 0 1 auto; min-width: 200px; margin-bottom: 15px;">
  <div [matTooltip]="getSectionNames(section)" [matTooltipDisabled]="!section?.length || !isInputDisabled">
    <mat-form-field appearance="outline" [style.width]="getSectionFieldWidth() + 'px'">
      <mat-label>Select Section <span style="color: red">*</span></mat-label>
      <mat-select [(ngModel)]="section" multiple placeholder="Select Section" (ngModelChange)="onSectionChange(section)"
        [disabled]="isInputDisabled">
        <mat-option *ngFor="let item of section_data" [value]="item.id" [disabled]="item.disabled">
          {{ item.section_name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
    
    <!-- <div style="flex: 0 1 auto; min-width: 200px; margin-bottom: 15px;">
      <mat-form-field appearance="outline" style="width: 200px;">
        <mat-label>Sales Order No</mat-label>
        <input matInput type="text" [(ngModel)]="so_no" placeholder="Sales Invoice No" disabled>
      </mat-form-field>
    </div> -->
    <!-- <div style="flex: 0 1 auto; min-width: 200px; margin-bottom: 15px;">
      <mat-form-field appearance="outline" style="width: 200px;">
        <mat-label>Document Type</mat-label>
        <mat-select [(ngModel)]="document_type" [disabled]="isUpdateMode">
          <mat-option *ngFor="let type of documentTypes" [value]="type">
            {{ type }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->
    <div style="flex: 0 1 auto; min-width: 200px; margin-bottom: 15px;">
      <mat-form-field appearance="outline" style="width: 250px;">
        <mat-label>Reference document no</mat-label>
        <input matInput type="text" [(ngModel)]="reference_doc" placeholder="Reference document no"  [disabled]="isInputDisabled">
      </mat-form-field>
    </div>
    <div style="flex: 0 1 auto; min-width: 200px; margin-bottom: 15px;">
      <mat-form-field appearance="outline" style="width: 250px;">
        <mat-label> Customer PO/WO document no</mat-label>
        <input matInput type="text" [(ngModel)]="document_no" placeholder="Customer PO/WO document no"  [disabled]="isInputDisabled">
      </mat-form-field>
    </div>
    <div style="flex: 0 1 auto; min-width: 200px; margin-bottom: 15px;">
      <mat-form-field appearance="outline" style="width: 200px;">
        <mat-label>Customer PO/WO document date<span style="color: red">*</span></mat-label>
        <input type="date" matInput [(ngModel)]="so_date"  class="custom-input" [max]="maxDate"  [disabled]="isViewMode" (keydown)="$event.preventDefault()">
      </mat-form-field>
    </div>

    <!-- <div style="flex: 1;">
  <mat-form-field appearance="outline">
  <mat-label>Select Customer contact person</mat-label>
  <mat-select [(ngModel)]="contact_type_id">
    <ng-container *ngFor="let group of groupedContactPersons">
      <mat-optgroup [label]="group.contact_type">
        <mat-option *ngFor="let person of group.items" [value]="person.id">
          {{ person.name }}
        </mat-option>
      </mat-optgroup>
    </ng-container>
  </mat-select>
</mat-form-field>
</div> -->
<div style="flex: 0 1 auto; min-width: 200px; margin-bottom: 15px;">
  <mat-form-field appearance="outline" style="width: 250px;">
    <mat-label>Contact Person Name</mat-label>
    <mat-select [(ngModel)]="selectedContactPersonId" disabled>
      <mat-option *ngFor="let person of contactPersons" [value]="person.contact_person_id">
        {{ person.contact_person_name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

</div>

</app-ui-form-section>

  <div *ngIf="panelMode !== 'view'" class="card mat-elevation-z4" style="background-color: #f0f0f0; padding: 20px; margin-top: 20px;">
    <form [formGroup]="productForm" (ngSubmit)="detail()" style="display: flex; flex-wrap: wrap; gap: 10px;">
      <div style="flex: 1;">
        <mat-form-field appearance="outline" style="width: 80%;">
          <mat-label>Select Profit/Cost Center</mat-label>
          <mat-select formControlName="selectedProfitCostId" placeholder="Select Profit/Cost Center" (selectionChange)="lineItemSection($event.value)">
            <mat-option *ngFor="let pc of selectedProfitCosts" [value]="pc.id">
              {{ pc.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div style="flex: 1;">
        <mat-form-field appearance="outline" style="width: 80%;">
          <mat-label>Select Section</mat-label>
          <mat-select formControlName="selectedSectionId" placeholder="Select Section">
            <mat-option *ngFor="let section of filteredHeaderSection" [value]="section.id">
              {{ section.section_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- Document Type -->
      <div style="flex: 1;">
        <mat-form-field appearance="outline" style="width: 80%;">
          <mat-label>Type</mat-label>
          <mat-select formControlName="line_document_type" (selectionChange)="onDocumentTypeChange($event.value)">
            <mat-option *ngFor="let type of documentTypes" [value]="type">
              {{ type }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- HSN/SAC -->
      <div style="flex: 1;">
        <mat-form-field appearance="outline" style="width: 80%;">
          <mat-label>Select HSN/SAC</mat-label>
          <mat-select formControlName="hsn_no" required (selectionChange)="onHsnSacChange($event.value)">
            <mat-option *ngFor="let item of companyHsnSac" [value]="item">
              {{ item.hsn_no }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- Sku/Service -->
      <div style="flex: 1;">
        <mat-form-field appearance="outline" >
          <mat-label>Select Item/Service</mat-label>
          <mat-select formControlName="item_id" (selectionChange)= "onSelectionChange($event.value)" required>
            <mat-option *ngFor="let item of filteredNames" [value]="item">
              {{ item.item_name || item.service_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- UOM -->
      <div style="flex: 1;">
        <mat-form-field appearance="outline" style="width: 80%;">
          <mat-label>Unit of Measure (UOM)</mat-label>
          <!-- <input matInput formControlName="uom" placeholder="Unit of Measure" [readonly]="isUom" /> -->
          <mat-select formControlName="uom" required>
            <mat-option *ngFor="let unit of unit_data" [value]="unit">
              {{ unit.unit_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    
      <div style="flex: 1;">
        <mat-form-field appearance="outline" style="width: 80%;">
          <mat-label>Line Documnet No</mat-label>
          <input matInput type="text" formControlName="line_document_no" placeholder="Line Documnet No">
        </mat-form-field>
      </div>
    
      <div style="flex: 1;">
        <mat-form-field appearance="outline" style="width: 80%;">
          <mat-label>Product/service No</mat-label>
          <input matInput type="text" formControlName="product_service_no" placeholder="Product/service No">
        </mat-form-field>
      </div>
    
      <!--StoreId-->
      <div style="flex: 1;">
        <mat-form-field appearance="outline" style="width: 80%;">
          <mat-label>Store </mat-label>
          <input matInput formControlName="store_data" min="1" [readonly]="isStore" />
        </mat-form-field>
        <input type="hidden" formControlName="store_id" />
      </div>
    
      <!-- Quantity -->
      <div style="flex: 1;">
        <mat-form-field appearance="outline" style="width: 80%;">
          <mat-label>Quantity</mat-label>
          <input type="number" matInput formControlName="quantity" (keypress)="allowOnlyNumbers($event)" required />
        </mat-form-field>
      </div>
    
      <!-- Price -->
      <div style="flex: 1;">
        <mat-form-field appearance="outline" style="width: 80%;">
          <mat-label>Price</mat-label>
          <input type="number" matInput formControlName="price" (keypress)="allowOnlyNumbers($event)" required />
        </mat-form-field>
      </div>
    
      <!-- Discount -->
      <!-- <div style="flex: 1;">
            <mat-form-field appearance="outline">
              <mat-label>Discount</mat-label>
              <input type="number" matInput formControlName="discount" min="0" />
            </mat-form-field>
          </div> -->
    
      <!--line description-->
      <div style="flex: 1;">
        <mat-form-field appearance="outline" style="width: 80%;">
          <mat-label>Description</mat-label>
          <input matInput formControlName="line_description" min="1" required />
        </mat-form-field>
      </div>
      <!-- StartDate -->
      <div style="flex: 1;">
        <mat-form-field appearance="outline" style="width: 80%;">
          <mat-label>Start Date</mat-label>
          <input type="date" matInput formControlName="start_date" min="1" required (keydown)="$event.preventDefault()"/>
        </mat-form-field>
      </div>
    
      <!-- EndDate -->
      <div style="flex: 1;">
        <mat-form-field appearance="outline" style="width: 80%;">
          <mat-label>End Date</mat-label>
          <input type="date" matInput formControlName="end_date" min="1" required (keydown)="$event.preventDefault()"/>
          <mat-error *ngIf="productForm.get('end_date')?.hasError('endBeforeStart')">
            End date cannot be smaller than start date.
          </mat-error>
        </mat-form-field>
      </div>

       <!-- <div style="flex: 1;">
         <mat-form-field appearance="outline" style="width: 80%;">
           <mat-label>Select Profit/Cost Center</mat-label>
           <mat-select formControlName="selectedProfitCostId" placeholder="Select Profit/Cost Center">
             <mat-option *ngFor="let pc of selectedProfitCosts" [value]="pc.id">
         {{ pc.name }}
        </mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->
   
      <!-- Add Product Button -->
      <div style="flex: 1; display: flex; justify-content: flex-end;">
        <button mat-raised-button color="primary" style="background-color: #4CAF50;" type="submit">Add
          Product/Service</button>
      </div>
    </form>
    <div style="flex: 1;">
      <mat-form-field appearance="outline" style="width: 20%;">
        <mat-label>Select Label</mat-label>
        <mat-select [(ngModel)]="selectedLabel" placeholder="Select Label">
          <mat-option *ngFor="let label of flattenedLabels" [value]="label">
            {{ label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <button mat-button class="btn btn-sm btn-success" (click)="summary()">Add Summary Line</button>
    </div>
  </div>

<!------customer detials-->
<div *ngIf="showDetails">
  <h3>Customer Branch Details</h3>
  <div style="margin-top: 20px; border: 1px solid #000; padding: 10px;width: 50%">
    <table style="width: 100%; border-collapse: collapse; margin-top: 5px;">
      <tr>
        <td style="width: 50%; padding: 5px;"><strong>Branch Name:</strong>{{ customerdetails.branch_name || 'NA' }}
        </td>
        <td style="width: 50%; padding: 5px;"><strong>GST No:</strong>{{ customerdetails.gst_number || 'NA' }}</td>
      </tr>
      <tr>
        <td style="width: 50%; padding: 5px;"><strong>Email:</strong>{{ customerdetails.email || 'NA' }}</td>
        <td style="width: 50%; padding: 5px;"><strong>Phone:</strong>{{ customerdetails.phone || 'NA' }}</td>
      </tr>
      <tr>
        <td style="width: 50%; padding: 5px;"><strong>Address:</strong>{{ customerdetails.address || 'NA' }}</td>
      </tr>
    </table>
  </div>
</div>

<!----selected products---->
<div>
  <h3>Selected Products</h3>
  <ul>
    <ng-container *ngFor="let label of labels">
      <li>
        <div style="border: 1px solid black; padding: 10px; margin-bottom: 10px; position: relative;">
          <button mat-icon-button color="warn" (click)="deleteLabelAndProducts(label)"
            style="position: absolute; top: 5px; right: 5px;" *ngIf="!isInputDisabled">
            <img src="assets/img/delete.gif" alt="Delete" width="34" height="34">
          </button>
          <strong>Line{{ label.level }}:</strong>
          <mat-form-field appearance="outline" style="width: 80%;">
            <mat-label>Description for Line{{ label.level }}</mat-label>
            <input matInput [(ngModel)]="label.description" placeholder="Enter description"  [disabled]="isInputDisabled"/>
          </mat-form-field>
          <div class="ui-doc-panel-table-scroll">
          <table class="ui-doc-line-table" style="margin-top: 10px;" border="1">
            <thead>
              <tr>
                <th>Line Documnet No</th>
                <th>Product Service No</th>
                <th>Item/Service Name</th>
                <th>Description</th>
                <th>Unit Name</th>
                <th>HSN/SAC No</th>
                <th>Store Name</th>
                <th>Quantity</th>
                <th>Unit Price</th>
                <th>Price</th>
                <th>CGST</th>
                <th>SGST</th>
                <th>IGST</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Profit/Cost Center</th>
                <th>Section</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let product of label.products">
                <!-- <td>{{ product?.sku_name }}</td> -->
                <td matTooltip="{{ product?.line_document_no }}" matTooltipShowDelay="750">{{ product?.line_document_no }}</td>
                <td matTooltip="{{ product?.product_service_no }}" matTooltipShowDelay="750">{{ product?.product_service_no }}</td>
                <!-- <td>{{ product?.item_name }}</td> -->
                <td matTooltip="{{ product.sku_product_type === 'SKU' ? product?.item_name : product?.service_name }}" matTooltipShowDelay="750">{{ product.sku_product_type === 'SKU' ? product?.item_name : product?.service_name }}</td>
                <td matTooltip="{{ product?.line_description }}" matTooltipShowDelay="750">{{ product?.line_description }}</td>
                <td matTooltip="{{ product?.uom }}" matTooltipShowDelay="750">{{ product?.uom }}</td>
                <td matTooltip="{{ product?.hsn_no }}" matTooltipShowDelay="750">{{ product?.hsn_no }}</td>
                <td matTooltip="{{ product?.store_data }}" matTooltipShowDelay="750">{{ product?.store_data }}</td>
                <td matTooltip="{{ product?.quantity | number:'1.3-3'}}" matTooltipShowDelay="750">{{ product?.quantity | number:'1.3-3'}}</td>
                <td matTooltip="{{ product?.unit_price | number:'1.2-2'}}" matTooltipShowDelay="750">{{ product?.unit_price | number:'1.2-2'}}</td>
                <td matTooltip="{{ label?.subLabels?.length == 0 ? 0 :(product?.price | number: '1.2-2') }}" matTooltipShowDelay="750">{{ label?.subLabels?.length == 0 ? 0 :(product?.price | number: '1.2-2') }}</td>
                <td></td>
                <td></td>
                <td></td>
                <td matTooltip="{{ label?.subLabels?.length == 0 ? '' :(product?.start_date) }}" matTooltipShowDelay="750">{{ label?.subLabels?.length == 0 ? '' :(product?.start_date) }}</td>
                <td matTooltip="{{ label?.subLabels?.length == 0 ? '' :(product?.end_date) }}" matTooltipShowDelay="750">{{ label?.subLabels?.length == 0 ? '' :(product?.end_date) }}</td>
                <td matTooltip="{{ product?.profit_cost_name }}" matTooltipShowDelay="750">{{ product?.profit_cost_name }}</td>
                <td matTooltip="{{ product?.section_name }}" matTooltipShowDelay="750">{{ product?.section_name }}</td>
              </tr>
            </tbody>
          </table>
          </div>
          <ng-container *ngFor="let subLabel of label.subLabels">
            <ng-container *ngTemplateOutlet="renderLabel; context: { $implicit: subLabel }"></ng-container>
          </ng-container>
        </div>
      </li>
    </ng-container>
  </ul>
</div>
<ng-template #renderLabel let-subLabel>
  <li style="margin-left: 30px;margin-top: 20px;">
    <strong>Line{{ subLabel.level }}:</strong>
       <div style="display: flex; align-items: center; justify-content: space-between;">
      <div style="display: flex; align-items: center; flex: 1;">
        <mat-form-field appearance="outline" style="width: 80%;">
          <mat-label>Description for Line{{ subLabel.level }}</mat-label>
          <input matInput [(ngModel)]="subLabel.description" placeholder="Enter description"  [disabled]="isInputDisabled" />
        </mat-form-field>
      </div>
      <button mat-icon-button color="warn" (click)="deleteSubLabel(subLabel)" *ngIf="!isInputDisabled">
        <img src="assets/img/delete.gif" alt="Delete" width="34" height="34">
      </button>
    </div>
    <div class="ui-doc-panel-table-scroll">
      <table class="ui-doc-line-table" style="margin-top: 10px;" border="1">
      <thead>
        <tr>
          <th>Line Documnet No</th>
          <th>Product Service No</th>
          <th>Item/Service Name</th>
          <th>Description</th>
          <th>Unit Name</th>
          <th>HSN/SAC No</th>
          <th>Store Name</th>
          <th>Quantity</th>
          <th>Unit Price</th>
          <th>Price</th>
          <th>CGST</th>
          <th>SGST</th>
          <th>IGST</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Profit/Cost Center</th>
          <th>Section</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of subLabel.products">
          <!-- <td>{{ product?.sku_name }}</td> -->
          <!-- <td>{{ product?.line_document_no }}</td> -->
          <td> <mat-form-field appearance="outline">
          <input matInput type="text" [(ngModel)]="product.line_document_no"  [disabled]="isInputDisabled">
          </mat-form-field></td>
          <!-- <td>{{ product?.product_service_no }}</td> -->
          <td> <mat-form-field appearance="outline">
          <input matInput type="text" [(ngModel)]="product.product_service_no"  [disabled]="isInputDisabled">
          </mat-form-field></td>
          <!-- <td>{{ product?.item_name }}</td> -->
          <td>{{ product.sku_product_type === 'SKU' ? product?.item_name : product?.service_name }}</td>
          <!-- <td>{{ product?.line_description }}</td> -->
          <td> <mat-form-field appearance="outline">
          <input matInput type="text" [(ngModel)]="product.line_description"  [disabled]="isInputDisabled">
          </mat-form-field></td>
          <td>{{ product?.uom}}</td>
          <td>{{ product?.hsn_no }}</td>
          <td>{{ product?.store_data }}</td>
          <!-- <td><mat-form-field appearance="outline">
            <input matInput type="number" [(ngModel)]="product.quantity" (ngModelChange)="onQtyChange(subLabel,product.quantity,product.unit_price)" (keypress)="allowOnlyNumbers($event)" required  [disabled]="isInputDisabled">
          </mat-form-field></td>  -->
            <td>
              <mat-form-field appearance="outline">
                <input matInput type="number" [(ngModel)]="product.quantity"
                  (ngModelChange)="onQtyChange(subLabel,product.quantity,product.unit_price,product)"
                  (keypress)="allowOnlyNumbers($event)" required
                  [disabled]="isInputDisabled"
                 min="0.001" step="0.001">
              </mat-form-field>
              <div *ngIf="types === 'reopen'" style="font-size:11px; margin-top:2px;">
                <span *ngIf="product.qty_disabled" style="color:red;">
                  ⛔ Fully dispatched
                </span>
                <span *ngIf="!product.qty_disabled && product.min_qty > 0" style="color:orange;">
                  ⚠ Already used: {{ product.min_qty | number:'1.3-3' }}
                </span>
              </div>
            </td>
            <!-- <td>{{ product?.unit_price }}</td> -->
          <td><mat-form-field appearance="outline">
            <input matInput type="number" [(ngModel)]="product.unit_price" (ngModelChange)="onPriceChange(subLabel,product.quantity,product.unit_price)" (keypress)="allowOnlyNumbers($event)" required  [disabled]="isInputDisabled">
          </mat-form-field></td>
          <td>{{ product?.price | number: '1.2-2' }}</td>
          <td>{{ cgstAmount(product?.quantity,product?.unit_price,product?.gst_percentage) }} ({{  getCGSTPercentage(product?.gst_percentage)}} %)</td>
          <td>{{ sgstAmount(product?.quantity,product?.unit_price,product?.gst_percentage) }} ({{  getSGSTPercentage(product?.gst_percentage)}} %)</td>
          <td>{{ igstAmount(product?.quantity,product?.unit_price,product?.gst_percentage) }} ({{  getIGSTPercentage(product?.gst_percentage)}} %)</td>
          <td>{{ product?.start_date }}</td>
          <td>{{ product?.end_date }}</td>
          <td>{{ product?.profit_cost_name }}</td>
          <td>{{ product?.section_name }}</td>
        </tr>
      </tbody>
    </table>
    </div>
    <ng-container *ngFor="let nestedSubLabel of subLabel.subLabels">
      <ng-container *ngTemplateOutlet="renderLabel; context: { $implicit: nestedSubLabel }"></ng-container>
    </ng-container>
  </li>
</ng-template>

<div class="gst-summary" *ngIf="gstSummary && gstSummary.length > 0">
  <h3 class="gst-title">GST Summary</h3>
  <i class="gst-subtitle">
    (Customer GST Type: <strong>{{ customerGstType }}</strong>)
  </i>
  <table class="gst-table">
    <thead>
      <tr>
        <th>GST %</th>
        <th>CGST</th>
        <th>SGST</th>
        <th>IGST</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let gst of gstSummary">
        <td>{{ gst?.gst_percent }}%</td>
        <td>{{ gst?.cgst }}</td>
        <td>{{ gst?.sgst }}</td>
        <td>{{ gst?.igst }}</td>
      </tr>
    </tbody>
  </table>
</div>

  <app-ui-form-section title="Terms and Conditions" icon="attach_file">
    <app-ui-document-file-upload
      [disabled]="isInputDisabled"
      [files]="myFiles"
      [showViewLink]="!!data?.id"
      (filesSelected)="onFileSelected($event)"
      (removeFile)="removeFile($event)"
      (viewFiles)="openFileShowModal()">
    </app-ui-document-file-upload>
  </app-ui-form-section>

  <app-ui-document-panel-footer
    [primaryActions]="footerPrimaryActions"
    [secondaryActions]="footerSecondaryActions"
    [destructiveAction]="footerDestructiveAction"
    [overflowActions]="footerOverflowActions"
    (actionClick)="onFooterAction($event)">
  </app-ui-document-panel-footer>

</app-ui-document-panel-shell>